import { render } from "./SegmentControl.vue?vue&type=template&id=1be64ef7&scoped=true"
import script from "./SegmentControl.vue?vue&type=script&lang=js"
export * from "./SegmentControl.vue?vue&type=script&lang=js"

import "./SegmentControl.vue?vue&type=style&index=0&id=1be64ef7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be64ef7"]])

export default __exports__